import { Component, ViewContainerRef} from '@angular/core';
import { SystemSettingService } from '../../services/system-settings/system-setting.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
import { ReportService } from '../../services/report/report.service';
import { SelectList } from '../../models/shared/shared.model';
import { SalesFilter, ReportSale } from '../../models/report/sale.model';
import { CategoryService } from '../../services/category/category.service';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
 
@Component({
  selector: 'rpt-sales',
  templateUrl: './rpt-sales.component.html',
  styleUrls: ['./rpt-sales.component.css']
})

export class RptSalesComponent {
  public brands: SelectList[] = [];
  public category: SelectList[] = [];
  public stores: SelectList[] = [];
  public shippingMethods: SelectList[] = [];
  public statuses: SelectList[] = [];
  public saleFilter: SalesFilter = new SalesFilter();
  public reportSale: ReportSale[] = [];
  public isDeleteAllowed: boolean = false;
  public isEditSimpleAllowed: boolean = false;
  public isEditVariableAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public filterStatus: string = "All";
  public filterStore: string = "All";
  public filterBrand: string = "All";
  public filterCategory: string = "All";
  public totalNetSales: number;
  public totalNetProfit: number;
  public totalCommission: number;
  public categoryList: DisplayCategory[] = [];
  public displayCategoryList: DisplayCategory[] = [];
  constructor(private readonly SystemSettingService: SystemSettingService,
    private readonly reportService: ReportService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly categoryService: CategoryService,private readonly rolePermissionService: RolePermissionService, private readonly router: Router, private utilityService: UtilitiesService) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.preBind();
    this.saleFilter.StoreId = 0;
    this.saleFilter.StatusId = 0;
    this.saleFilter.ShippingId = 0;
    this.saleFilter.BrandId = 0;
    this.saleFilter.CategoryId = 0;
  }

  checkPermission() {
    this.rolePermissionService.GetRolePermissions("product").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "editsimple");
          });
          var editVariable = data.filter(function (element) {
            return (element.action == "editvariable");
          });
          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditSimpleAllowed = true;
          if (editVariable.length > 0)
            this.isEditVariableAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  preBind() {
    this.categoryService.GetAllCategoryList().subscribe(data => {
      this.categoryList = data;
      this.displayCategoryList = this.categoryList.filter(i => i.parentCategoryID === 0);
      this.displayCategoryList.forEach(element => {
        element.subCategory = this.categoryList.filter(i => i.parentCategoryID === element.categoryID);
        element.subCategory.forEach(child => {
          child.subCategory = this.categoryList.filter(i => i.parentCategoryID === child.categoryID);
        });
      });
    })
    this.reportService.SaleReportPreBind().subscribe(
      d => {
        if (d.success) {
          this.stores = d.data.stores;
          this.shippingMethods = d.data.shippingMethods;
          this.statuses = d.data.statuses;
          this.brands = d.data.brands;
          this.category = d.data.category;
        }
        else
          this.toastr.error(d.message);

      }
    )
  }
  generateReport(isPrint: boolean, btnT: any) {
    if (this.saleFilter.StatusId != 0)
      this.filterStatus = this.statuses.find(x => x.id == String(this.saleFilter.StatusId)).name;
    else
      this.filterStatus = "All";

    if (this.saleFilter.StoreId != 0)
      this.filterStore = this.stores.find(x => x.id == String(this.saleFilter.StoreId)).name;
    else
      this.filterStore = "All";

    if (this.saleFilter.BrandId != 0)
      this.filterBrand = this.brands.find(x => x.id == String(this.saleFilter.BrandId)).name;
    else
      this.filterBrand = "All";

    if (this.saleFilter.CategoryId != 0)
      this.filterCategory = this.category.find(x => x.id == String(this.saleFilter.CategoryId)).name;
    else
      this.filterCategory = "All";

    var currentTarget = btnT.currentTarget;
    this.utilityService.toggleButtonAnimation(currentTarget)
    this.reportService.SaleReportFetch(this.saleFilter).subscribe(
      d => {
        this.utilityService.toggleButtonAnimation(currentTarget);

        if (d.success) {
          this.reportSale = d.data.report;
          this.totalNetSales = d.data.totalNetSales;
          this.totalNetProfit = d.data.totalNetProfit;
          this.totalCommission = d.data.totalCommission;
          var p = this.utilityService;
          if (isPrint)
            setTimeout(function () { p.print(); }, 2000);
        }
        else
          this.toastr.error(d.message);

      }
    )
  }



}



// WEBPACK FOOTER //
// ./src/app/Reports/rpt-sales/rpt-sales.component.ts